import React, { useCallback, useContext, useState, useEffect } from 'react';
import { companyPageContext } from '@/components/NewCompanyPage/NewCompanyPage';
import CompanyPurchasesReport from '@/components/CompanyPurchasesReport/CompanyPurchasesReport';
import ManageCategories from '@/components/CompanyConfig/ManageCategories';
import AccessibleMarkets from '@/components/CompanyConfig/AccessibleMarkets';
import ApprovedMarkets from '@/components/CompanyConfig/ApprovedMarkets';
import ManageOmniCategories from '@/components/CompanyConfig/ManageOmniCategories';
import ManageOshCategories from '@/components/CompanyConfig/ManageOshCategories';
import OmniApprovedMarkets from '@/components/CompanyConfig/OmniPriorApprovedMarkets';
import InviteUsers from '@/components/NewCompanyPage/InviteUsers';
import ExtendTrial from '@/components/ExtendTrial/ExtendTrial';
import generalStyles from '@/components/General/Styles.module.scss';
import { getNsCompanyData } from '@/services/api/company.service';
import API_STATES from '@/constants/StateConstants';
import store from '../../store';
import styles from '@/components/CompanyConfig/CompanyConfig.module.scss';
import { Collapse } from 'antd';
import './Accordion.scss';
import 'antd/lib/collapse/style/index.css';
import AddProducts from '@/components/CompanyConfig/AddProducts';
import Brands from '../CompanyConfig/Brands';
import InviteMultiCompanyUsers from './InviteMultiCompanyUsers';
import copyIcon  from '@images/icons/niq-copy-dark.svg'
import greenCheckMarkIcon from '@images/icons/circle-check-green.svg'
import AttachQuotes from '../CompanyConfig/Quotes/AttachQuotes';


const { Panel } = Collapse;

export default function Company() {
    let { nsCompanyId, companyConfig: { companyName, companyAccessLevel, isMultiCompany, companyDomains, companyId, tenantId, categories: tenantCategories } } = useContext(companyPageContext);
    const [openPanels, setOpenPanels] = useState([]);
    // const params = useParams();
    const [companyData, setCompanyData] = useState({});
    const [refreshTimestamp, setRefreshTimestamp] = useState(null);
    const [copyStatus, setCopyStatus] = useState({companyId: false, nsCompanyId: false, tenantId: false})
    const [localTenantCategories, setLocalTenantCategories] = useState(tenantCategories);
    const onCategoriesLoaded = useCallback((categories) => {
        setLocalTenantCategories(categories);
    }, []);

    useEffect(() => {
        setLocalTenantCategories(tenantCategories);
    }, [tenantCategories]);

    const { isCsr, isSuperUser } = store?.getState()?.account ?? {};

    useEffect(() => {
        if (nsCompanyId) {
            setOpenPanels([]);
            getCompanyDetails(nsCompanyId);
        }
    }, [nsCompanyId]);

    async function getCompanyDetails(nsCompanyId) {
        const response = await getNsCompanyData(nsCompanyId);
        if (response.status === API_STATES.success) {
            setCompanyData(response.data);
        }
    }

    function onCopySelectedId (item, value) {
        if(value){
            navigator.clipboard.writeText(String(value))
            setCopyStatus({[item]: true})
            setTimeout(()=>{
                setCopyStatus({[item]: false})
            }, 3000)
        }
    }
    return (
        <>
            <div className={styles.rowFlex}>
                <div>
                    <h2 className={styles.heading}>
                        {companyName} 
                        {isMultiCompany && <span className={generalStyles.statusMessage}>(multi company)</span>}
                    </h2>
                    <strong>{companyAccessLevel}</strong>
                    <br/>
                    <strong>
                        Company Id: {companyId}
                        <img title={`Copy Company Id`} className={styles.icon} src={copyStatus.companyId ? greenCheckMarkIcon: copyIcon} alt="copy-icon" onClick={()=>onCopySelectedId('companyId', companyId)}/>   
                    </strong>
                    <br/>
                    <strong>
                        Netsuite Company Id: {nsCompanyId}
                        <img title={`Copy Netsuite Company Id`} className={styles.icon} src={copyStatus.nsCompanyId ? greenCheckMarkIcon: copyIcon} alt="copy-icon" onClick={()=>onCopySelectedId('nsCompanyId', nsCompanyId)}/>   
                    </strong>
                    <br/>
                    <strong>
                        Tenant Id: {tenantId}
                        <img title={`Copy Tenant Id`} className={styles.icon} src={copyStatus.tenantId ? greenCheckMarkIcon: copyIcon} alt="copy-icon" onClick={()=>onCopySelectedId('tenantId', tenantId)}/>   
                    </strong>
                </div>

            </div>
            <br />
            <Collapse
                activeKey={openPanels}
                onChange={setOpenPanels}
                className={'alerts-list-accordion'}
                expandIconPosition={'end'}
            >
                <Panel
                    header={
                        <div className={'alerts-list-panel-heading'}>
                            <span className={'alerts-list-panel-heading-title'}>
                                {<b>Company Purchases</b>}
                            </span>
                        </div>
                    }
                >
                    <CompanyPurchasesReport
                        nsCompanyId={nsCompanyId}
                        refreshTimestamp={refreshTimestamp}
                        refreshDelay={100000}
                        isEditable={isSuperUser} />
                </Panel>
                <Panel
                    header={
                        <div className={'alerts-list-panel-heading'}>
                            <span className={'alerts-list-panel-heading-title'}>
                                {<b>Brands</b>}
                            </span>
                        </div>
                    }
                >
                    <Brands nsCompanyId={nsCompanyId} isEditable={isCsr || isSuperUser} />
                </Panel>
                <Panel
                    header={
                        <div className={'alerts-list-panel-heading'}>
                            <span className={'alerts-list-panel-heading-title'}>
                                {<b>Categories</b>}
                            </span>
                        </div>
                    }
                >
                    <ManageCategories nsCompanyId={nsCompanyId} isEditable={isCsr || isSuperUser} onCategoriesLoaded={onCategoriesLoaded} />
                </Panel>
                <Panel
                    header={
                        <div className={'alerts-list-panel-heading'}>
                            <span className={'alerts-list-panel-heading-title'}>
                                {<b>Accessible Markets</b>}
                            </span>
                        </div>
                    }
                >
                    <AccessibleMarkets nsCompanyId={nsCompanyId} isEditable={isCsr || isSuperUser} />
                </Panel>
                <Panel
                    header={
                        <div className={'alerts-list-panel-heading'}>
                            <span className={'alerts-list-panel-heading-title'}>
                                {<b>Approved Markets</b>}
                            </span>
                        </div>
                    }
                >
                    <ApprovedMarkets nsCompanyId={nsCompanyId} isEditable={isCsr || isSuperUser} tenantCategories={localTenantCategories} />
                </Panel>
                <Panel
                    header={
                        <div className={'alerts-list-panel-heading'}>
                            <span className={'alerts-list-panel-heading-title'}>
                                {<b>Omnisales Categories</b>}
                            </span>
                        </div>
                    }
                >
                    <ManageOmniCategories nsCompanyId={nsCompanyId} isEditable={isCsr || isSuperUser} />
                </Panel>
                <Panel
                    header={
                        <div className={'alerts-list-panel-heading'}>
                            <span className={'alerts-list-panel-heading-title'}>
                                {<b>Omnisales Approved Markets</b>}
                            </span>
                        </div>
                    }
                >
                    <OmniApprovedMarkets nsCompanyId={nsCompanyId} isEditable={isCsr || isSuperUser} />
                </Panel>
                <Panel
                    header={
                        <div className={'alerts-list-panel-heading'}>
                            <span className={'alerts-list-panel-heading-title'}>
                                {<b>Omnishopper Categories</b>}
                            </span>
                        </div>
                    }
                >
                    <ManageOshCategories nsCompanyId={nsCompanyId} isEditable={isCsr || isSuperUser} />
                </Panel>
                <Panel
                    header={
                        <div className={'alerts-list-panel-heading'}>
                            <span className={'alerts-list-panel-heading-title'}>
                                {<b>Extend Trial Expiry</b>}
                            </span>
                        </div>
                    }
                >
                    <ExtendTrial nsCompanyId={nsCompanyId} isEditable={isCsr || isSuperUser} />
                </Panel>
                <Panel
                    header={
                        <div className={'alerts-list-panel-heading'}>
                            <span className={'alerts-list-panel-heading-title'}>
                                {<b>Invite Multi-Company User (Consultant)</b>}
                            </span>
                        </div>
                    }
                >
                    <InviteMultiCompanyUsers nsCompanyId={nsCompanyId} />
                </Panel>
                <Panel
                    header={
                        <div className={'alerts-list-panel-heading'}>
                            <span className={'alerts-list-panel-heading-title'}>
                                {<b>Invite Users</b>}
                            </span>
                        </div>
                    }
                >
                    <InviteUsers nsCompanyId={nsCompanyId} />
                </Panel>
                <Panel
                    header={
                        <div className={'alerts-list-panel-heading'}>
                            <span className={'alerts-list-panel-heading-title'}>
                                {<b>Add Products</b>}
                            </span>
                        </div>
                    }
                >
                    <AddProducts
                        nsCompanyId={nsCompanyId}
                        companyInfo={companyData}
                        setRefreshTimestamp={setRefreshTimestamp}
                    />
                </Panel>
                <Panel header={
                        <div className={'alerts-list-panel-heading'}>
                            <span className={'alerts-list-panel-heading-title'}>
                                {<b>Quote</b>}
                            </span>
                        </div>
                    }>
                        <AttachQuotes companyDomain={companyDomains} isEditable={isSuperUser} nsCompanyId={nsCompanyId}/>
                </Panel>
            </Collapse>
        </>
    );
}
